/* Printado – minimale JS: variantkeuze, AJAX winkelwagen, galerij, filters. */
(function () {
  'use strict';
  var money = function (cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
  };

  function initProduct(section) {
    var dataEl = section.querySelector('[data-variants]');
    var form = section.querySelector('[data-product-form]');
    if (!dataEl || !form) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = section.querySelector('[data-price] .price__now');
    var errEl = form.querySelector('[data-error]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('.opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var sel = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return sel[i] === null || sel[i] === o; });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Niet beschikbaar'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      if (v.featured_image) {
        var img = section.querySelector('#product-main-image');
        if (img && v.featured_image.src) { img.src = v.featured_image.src; img.removeAttribute('srcset'); }
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var ok = form.querySelector('[data-upload-ok]');
      if (ok && !ok.checked) {
        errEl.textContent = 'Bevestig eerst dat je je ontwerp hebt gecontroleerd.';
        errEl.hidden = false;
        ok.focus();
        return;
      }
      addBtn.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Toevoegen mislukt');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          var t = document.getElementById('cart-toast');
          if (t) { t.hidden = false; setTimeout(function () { t.hidden = true; }, 6000); }
        })
        .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
        .finally(function () { addBtn.disabled = false; });
    });

    section.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = section.querySelector('#product-main-image');
        if (img) { img.src = b.getAttribute('data-thumb'); img.removeAttribute('srcset'); }
        section.querySelectorAll('[data-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  function initFilters() {
    var f = document.getElementById('collection-filters');
    if (f) f.addEventListener('change', function () { f.submit(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initFilters();
  });
})();
